module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-74.901708f7.svg";